export default __webpack_public_path__ + "static/gulabjamunsyrup-81cc801f97c2039747d5d53d33d827ea.png";